import { defaultLicenseInfoState } from './module-licenseinfo-state';

export default {
	resetState(state) {
		Object.assign(state, defaultLicenseInfoState);
	},
	updateLicenseInfo(state, res) {
		state.licenseInfo = res;
	},

	updatePaggingOrder(state, res) {
		state.OrderList = res.Data.Data;
		state.TotalOrderList = res.Data.Total;
	}
};
